export const DASHBOARD_LOG_ERROR = 'DASHBOARD_LOG_ERROR';
export const DASHBOARD_ASYNC_START = 'DASHBOARD_ASYNC_START';
export const DASHBOARD_ASYNC_END = 'DASHBOARD_ASYNC_END';
export const FETCH_DASHBOARD_SUMMARY = 'FETCH_DASHBOARD_SUMMARY';
export const FETCH_WALLET_BALANCE = 'FETCH_WALLET_BALANCE';
export const FETCH_DASHBOARD_TRANSACTIONS = 'FETCH_DASHBOARD_TRANSACTIONS';
export const FETCH_TRANSACTIONS_FROM_SOURCE = 'FETCH_TRANSACTIONS_FROM_SOURCE';
export const UPDATE_DASHBOARD_FILTERS = 'UPDATE_DASHBOARD_FILTERS';
export const UPDATE_DASHBOARD_PAGINATION = 'UPDATE_DASHBOARD_PAGINATION';
export const CHECk_ACCOUNT_STATUS = 'CHECk_ACCOUNT_STATUS';
export const FETCH_OVERVIEW_GRAPH = 'FETCH_OVERVIEW_GRAPH';
export const FETCH_TRANSACTION_AMOUNT = 'FETCH_TRANSACTION_AMOUNT';
export const FETCH_TRANSACTION_VOLUME = 'FETCH_TRANSACTION_VOLUME';
